import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { LayoutToggleButton } from './LayoutToggleButton';
import { useScreenLayout } from './ScreenLayoutProvider';
import { TopbarDivider } from './styled';
export function SidebarToggleButton() {
    const { sidebar } = useScreenLayout();
    const openTooltip = t({
        message: 'Open sidebar',
        comment: 'Screen layout - Open sidebar button tooltip',
    });
    const closeTooltip = t({
        message: 'Close sidebar',
        comment: 'Screen layout - Close sidebar button tooltip',
    });
    const tooltip = sidebar.isOpen ? closeTooltip : openTooltip;
    return (<Fragment>
      <TopbarDivider $side="right"/>
      <LayoutToggleButton side="right" tooltip={tooltip} open={sidebar.isOpen} onClick={sidebar.toggle}/>
    </Fragment>);
}
